<template>
    <div tabindex="0" v-bind:aria-label="config.name ? config.name + ', page '+ pagination.page : ''" class="rmvue-grid">
        <div class="grid-tools-section" v-if="loading === false && data.length !== 0">
            <div class="grid-entries">
                <p>Show</p>
                <select aria-label="Show Entries" v-on:change="onEntriesChange">
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                </select>
                <p>entries</p>
            </div>
        </div>
         <div class="grid-loading-section" v-if="loading === true">
            <div class="loading-ring"><div></div><div></div><div></div><div></div></div>
        </div>
        <div class="grid-body-wrap">
            <div class="grid-header-section">
                <div class="data-row" role="row">
                    <div tabindex="0" role="columnheader" v-for="(col, cIndex) in columns" v-bind:key="col.id" class="data-col" v-bind:style="{'max-width':col.width}" v-on:click="onColumnClick(col, cIndex, $event)" v-on:keydown="onColumnClick(col, cIndex, $event)">
                        <div class="data-value"> {{  col.name }}
                            <div v-if="col.sort_field" class="sort-arrows" v-bind:class="{'direction-down':col.sort_order === 'DESC', 'direction-up':col.sort_order === 'ASC'}">
                                <div class="arrow-up"></div>
                                <div class="arrow-down"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-nodata-section" v-if="loading === false && data.length === 0">
                <div class="grid-nodata-text">{{ config.no_data_message ?  config.no_data_message : 'No Data Found'}}</div>
                <div class="grid-nodata-image"></div>
            </div>
            <div class="grid-body-section" v-if="loading === false && data.length !== 0">
                <div role="row" v-for="row in data" v-bind:key="row.id" class="data-row" v-on:click="onRowClick($event, row)" >
                    <div v-for="(col, cIndex) in columns" v-bind:key="col.id" class="data-col" v-bind:style="{'max-width':col.width}" v-on:click="onColumnClick(col, cIndex, $event)">
                        <div class="data-value mobile-header-name">{{  col.name }}:</div>
                        <div tabindex="0" role="cell" v-bind:aria-label="col.name + ', ' + getValue(row, col)" class="data-value" v-if="col.valueMapType !== 'html' && col.valueMapType !== 'filter'" >{{  getValue(row, col) }}</div>
                        <div tabindex="0" role="cell" v-bind:aria-label="col.name + ', ' + getValue(row, col, true)" class="data-value" v-if="col.valueMapType === 'html' || col.valueMapType === 'filter'" v-html="getValue(row, col)" ></div>
                    </div>
                </div>
            </div>
            <div class="grid-footer-section" v-if="loading === false && data.length !== 0">
                  <div class="grid-pagination-wrap">
                        <div tabindex="0" role="button" aria-label="Previous Page" class="grid-pagination-previous" v-on:click="previousPage($event)"  v-on:keydown="previousPage($event)">
                            <div><span></span></div>
                            <div>Prev</div>
                        </div>
                        <div class="grid-pagination-pages">
                             <div v-for="page in pagination.pagesList" v-bind:key="page.id" class="grid-pagination-page" v-bind:class="{'active':page.active}" v-on:click="changePage(page.value, $event)" v-on:keydown="changePage(page.value, $event)" >
                                <div  tabindex="0" role="button" v-bind:aria-label="'Page number '+page.value">{{  page.value }}</div>
                            </div>
                        </div>
                        <div tabindex="0" role="button" aria-label="Next Page" class="grid-pagination-next" v-on:click="nextPage($event)" v-on:keydown="nextPage($event)">
                            <div>Next</div>
                            <div><span></span></div>
                        </div>
                  </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'rmvue-grid',
    data: function () {
        return {
            count: 0,
            component: null,
            data: [],
            loading: false,
            sorting: {},
            pagination: {
                page: 1,
                per_page: 10,
                pagesList: [],
                nav_size: 5,
                nav_start: 1,
                nav_end: 5
            }
        }
    },
    components: { },
    filters: {
        currency: function (val) {
            return '$' + (val / 100).toFixed(2)
        },
        vGridButton: function (val) {
            let color = 'grey'
            let colorBlue = ['web', 'Web']
            if (colorBlue.indexOf(val) !== -1) {
                color = 'blue'
            }
            return '<div class="rm-grid-class-button ' + color + '">' + val || '' + '</div>'
        },
        vGridStatus: function (val) {
            return '<div class="rm-grid-class-status ' + (val ? val.toLowerCase() : '') + '"></div><div>' + val || '' + '</div>'
        }
    },
    props: {
        columns: Array,
        config: Object
    },
    computed: { },
    mounted () {
        this.pagination.nav_end = this.pagination.nav_size
        if (this.config && this.config.proxy === true) {
            if (this.config.pagination) {
                this.pagination.per_page = this.config.pagination.per_page
                this.pagination.page = this.config.pagination.page
            }
            this.loadGrid()
        }
    },
    methods: {
        eventHandler: function (event) {
            if (event && event.type === 'keydown' && (event.code === 'Space' || event.code === 'Enter')) {
                return true
            } else if (event && event.type === 'click') {
                return true
            } else {
                return false
            }
        },
        loadGrid: function () {
            const HttpRequestService = this.HttpService()
            const paramas = this.getParams()
            const vm = this
            vm.loading = true
            HttpRequestService.get(this.config.url, paramas).then(r => {
                this.data = r.data
                // this.data = []
                if (r.headers) {
                    this.pagination.total = parseInt(r.headers['x-total'])
                    this.pagination.pages = parseInt(r.headers['x-total-pages'])
                    this.pagination.next = r.headers['x-next-page']
                }
                this.loadFooterPagination()
                vm.loading = false
                if (this.config.events && this.config.events.onLoad) {
                    this.config.events.onLoad(r.data)
                }
                vm.getDomWhenReady('.rmvue-grid', (el) => {
                    vm.focusOn('.rmvue-grid', 500)
                })
            }).catch((error) => {
                vm.loading = false
                console.log(error)
            })
        },
        loadFooterPagination: function () {
            if (this.pagination.page > 0) {
                this.pagination.pagesList = []
                let min = this.pagination.nav_start
                let max = this.pagination.nav_size
                if (this.pagination.page > this.pagination.nav_end) {
                    this.pagination.nav_start = this.pagination.nav_end + 1
                    this.pagination.nav_end = this.pagination.nav_end + max
                    min = this.pagination.nav_start
                } else if (this.pagination.page < min) {
                    this.pagination.nav_start = this.pagination.nav_start - max
                    this.pagination.nav_end = (this.pagination.nav_start + max) - 1
                    min = this.pagination.nav_start
                }
                max = min + max
                for (let i = min; i <= max; i++) {
                    if (this.pagination.pagesList.length < this.pagination.nav_size && i <= this.pagination.pages) {
                        this.pagination.pagesList.push({
                            value: i,
                            active: this.pagination.page === i
                        })
                    } else {
                        break
                    }
                }
            }
        },
        sort: function (column, index) {
            this.pagination.sort = {}
            // Clear other sortings
            for (let i = 0; i < this.columns.length; i++) {
                if (i !== index && this.columns[i].sort_order) {
                    delete this.columns[i].sort_order
                }
            }
            if (this.columns[index].sort_order === undefined) {
                this.columns[index].sort_order = 'DESC'
            } else {
                if (column.sort_order === 'DESC') {
                    column.sort_order = 'ASC'
                } else if (column.sort_order === 'ASC') {
                    delete column.sort_order
                }
                this.columns[index].sort_order = column.sort_order
            }
            if (column.sort_order) {
                this.pagination.sort.sort_field = column.sort_field
                this.pagination.sort.sort_order = column.sort_order
            }
            this.loadGrid()
        },
        getParams: function () {
            let lobj = {}
            lobj.page = this.pagination.page
            lobj.per_page = this.pagination.per_page
            if (this.pagination.sort) {
                Object.assign(lobj, this.pagination.sort)
            }
            return lobj
        },
        onEntriesChange: function (event) {
            if (event.target && event.target.value) {
                this.pagination.per_page = parseInt(event.target.value)
                if (this.config.events && this.config.events.onEntriesChange) {
                    this.config.events.onEntriesChange(event.target.value)
                }
                this.changePage(1)
            }
        },
        onRowClick: function (event, row) {
            if (this.config.events && this.config.events.onRowClick) {
                this.config.events.onRowClick(row)
            }
        },
        onColumnClick: function (row, index, event) {
            if (this.eventHandler(event)) {
                if (this.config.events && this.config.events.onColumnClick) {
                this.config.events.onColumnClick(row)
                }
                if (row.sort_field) {
                    this.sort(row, index)
                }
            }
        },
        nextPage: function (event) {
            if (this.pagination.page < this.pagination.pages) {
                this.changePage(this.pagination.page + 1, event)
            }
        },
        previousPage: function (event) {
            if (this.pagination.page > 1) {
                this.changePage(this.pagination.page - 1, event)
            }
        },
        changePage: function (page, event) {
            if ((event && this.eventHandler(event)) || !event) {
                this.pagination.page = page
                if (this.config.events && this.config.events.onPaginate) {
                    this.config.events.onPaginate(page, this.pagination)
                }
                this.loadGrid()
            }
        },
        focusOn: function (selector, delay) {
            setTimeout(function () {
                const el = document.querySelector(selector)
                if (el) {
                    if (!el.getAttribute('tabindex')) {
                        el.setAttribute('tabindex', 0)
                    }
                    el.focus()
                }
            }, (delay || 300))
        },
        getDomWhenReady: function (elQuery, cb, retries, elapse, i) {
            i = i || 1
            retries = retries || 10
            elapse = elapse || 50
            const vm = this
            if (i && i >= retries && cb) {
                cb(false)
            } else {
                const check = function () {
                    const elm = document.querySelector(elQuery)
                    if (elm && cb) {
                        cb(elm)
                        return true
                    }
                    return false
                }
                if (!check()) {
                    setTimeout(function () {
                        if (!check()) {
                            vm.getDomWhenReady(elQuery, cb, retries, elapse, i + 1)
                        }
                    }, elapse)
                }
            }
        },
        getValue: function (row, col, plain) {
            /*
                Map Types
                Key: Search for the key name on the first level of the row data object
                Filter: Use filter to render the value
             */
            if (col.valueMapType === 'key') {
                if (typeof col.value === 'function') {
                    return row[col.value(row)]
                } else {
                    return row[col.value]
                }
            } if (col.valueMapType === 'filter') {
                let v
                if (typeof col.value === 'function') {
                    v = row[col.value(row)]
                } else {
                    v = row[col.value]
                }
                if (col.filter) {
                    const filter = this.$options.filters[col.filter]
                    if (filter) {
                        if (plain && filter(v).indexOf('div') !== -1) {
                            return v
                        } else {
                            return filter(v)
                        }
                    } else {
                        return v
                    }
                } else {
                    console.error('No filter name specified')
                    return v
                }
            } else {
                 if (typeof col.value === 'function') {
                    return col.value(row)
                } else {
                    return col.value
                }
            }
        }
     }
}
</script>



// WEBPACK FOOTER //
// src/components/rm-grid.vue